import styled from 'styled-components'

export const Container = styled.div`
  .ProfessionalContentHighlights__Card {
    margin-bottom: 20px;
    max-width: 100% !important;
    border-radius: 10px !important;
  }
`

export const MainContentWrapper = styled.a`
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E2E2;
  transition: all 0.2s;
  display: block;

  &:hover {
    opacity: 0.6;
    cursor: pointer;
  }
`

export const MainImage = styled.img`
  width: 100%;
  max-width: 344px;
  border-radius: 10px;
  margin-bottom: 15px;
`

export const MainContent = styled.div``

export const ContentsWrapper = styled.div`
  margin: 20px 0 30px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ContentWrapper = styled.a`
  display: flex;

 &:hover {
    opacity: 0.6;
    cursor: pointer;
  }
`

export const ContentImage = styled.img`
  width: 100%;
  max-width: 130px;
  border-radius: 10px;
  height: 70px;
  margin-right: 15px;
`

export const ContentTextWrapper = styled.div``

export const Link = styled.a`
  font-size: 15px;
  font-weight: bold;
  color: #1F35B5;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`